import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PasswordRecovery: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const mobile = searchParams.get('mobile');

  useEffect(() => {
    if (!token || !mobile) return;

    const isMobile = mobile === 'true';

    const erpUrl = `/nova-senha?token=${token}&mobile=${mobile}`;

    if (!isMobile) {
      navigate(erpUrl);
      return;
    }

    const appDeepLink = `ministeriobelem://reset-password/${token}`;

    window.location.href = appDeepLink;

    const fallbackTimeout = setTimeout(() => {
      if (!document.hidden) {
        navigate(erpUrl);
      }
    }, 500);

    return () => clearTimeout(fallbackTimeout);
  }, [token, mobile, navigate]);

  return <div>Redirecionando...</div>;
};

export default PasswordRecovery;
